<template>
  <!-- 发票查询界面 -->
  <div>
    <pop-modal
      :visible="visible"
      :isDrag="true"
      :title="`增值税${kpdate.taxClass == 0 ? '专用' : '普通'}发票查询`"
      :width="900"
      @cancel="handelCancel"
    >
      <div class="wrap">
        <div class="main">
          <div class="main-top">
            <div></div>
            <div>
              <a-button type="primary" ghost>二维码</a-button>
              <!-- <a-button type="primary" ghost>发送邮件</a-button>
              <a-button type="primary" ghost>下载</a-button> -->
              <a-button type="primary" ghost @click="chonghong()">冲红</a-button>
              <a-button type="primary" ghost @click="priceChange()">含税</a-button>
              <a-button type="primary" ghost>不含税</a-button>
              <a-button type="primary" ghost @click="showPrint()">打印</a-button>
            </div>
          </div>
          <div class="main-cont">
            <!-- 显示页面 -->
            <div
              class="cont-invoice"
              v-show="!isInPrint"
              :class="kpdate.taxClass == 0 ? 'zy' : kpdate.taxClass == 1 ? 'pt' : 'dz'"
            >
              <div class="invoice-header">
                <span :style="{ left: kpdate.taxClass == 3 ? '304px' : '348px' }">{{ enterprise.domainName }}</span>
              </div>
              <div class="invoce-invalid" v-if="kpdate.isVoid === 'Y'">
                <img src="@/assets/invalid.png" alt="" />
                <span>作废时间：{{ kpdate.voidDate | filterDate }}</span>
              </div>
              <div class="invoice-no">
                <div class="version" v-if="kpdate.isVoid !== 'Y'"><span>税收分类编码版本号:39.0</span></div>
                <div>
                  <select name="" id="" class="code">
                    <option value="1">{{ kpdate.taxBillCode }}</option>
                  </select>
                  <select name="" id="" class="number">
                    <option value="1">{{ kpdate.taxBillNo }}</option>
                  </select>
                  <div class="date">
                    <span>{{ enterprise.taxBillDate | filterDate }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-buyer">
                <div class="left">
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerName" />
                    <a-icon type="plus-square" class="addImg" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerTaxpayerId" />
                    <a-icon type="plus-square" class="addImg" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerAddress" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerAccounts" />
                  </div>
                </div>
                <div class="right" v-if="kpdate.taxClass === 3">
                  <input type="text" />
                  <input type="text" />
                  <input type="text" />
                </div>
              </div>
              <div class="invoice-table" style="min-height: 189px">
                <div class="table-header tab">
                  <div style="flex: 2.3">货物或应税劳务、服务名称</div>
                  <div style="flex: 1.15">规格型号</div>
                  <div style="flex: 0.6">单位</div>
                  <div style="flex: 0.95">数量</div>
                  <div style="flex: 1.3">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 0.5">税率</div>
                  <div style="flex: 1.8">税额</div>
                </div>
                <div class="table-content tab" :class="isRed ? 'red' : ''" v-for="(data, i) in kpList" :key="i">
                  <!-- 货物或应税劳务、服务名称 -->
                  <div style="flex: 2.3">
                    <div class="relative">
                      <input type="text" v-model="data.goodsName" :readonly="!onlyQd" />
                      <a-icon type="plus-square" class="addImg" @click="!onlyQd" />
                    </div>
                  </div>
                  <!-- 规格型号 -->
                  <div style="flex: 1.15">
                    <input type="text" v-model="data.goodsGauge" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 单位 -->
                  <div style="flex: 0.6">
                    <input type="text" v-model="data.goodsUnits" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 数量 -->
                  <div style="flex: 0.95">
                    <input
                      type="number"
                      v-model="data.goodsAmounts"
                      @change="goodsAmountsChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 单价 -->
                  <div style="flex: 1.3">
                    <input
                      type="number"
                      v-model="data.goodsUnitPrice"
                      @change="goodsUnitPriceChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 金额 -->
                  <div style="flex: 1.5">
                    <input
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      readonly
                    />
                  </div>
                  <!-- 税率 -->
                  <div style="flex: 0.5">
                    <select
                      v-model="data.goodsTaxRates"
                      @change="rateChange(i)"
                      :disabled="data.goodsName && isDisOnly(data, i)"
                    >
                      <option value="0.13">13%</option>
                      <option value="0.09">9%</option>
                      <option value="0.06">6%</option>
                      <option value="0.05">5%</option>
                      <option value="0.03">3%</option>
                      <option value="0.01">1%</option>
                      <option value="0.00">0%</option>
                      <option value="0.00">免税</option>
                      <option value="0.04">4%</option>
                    </select>
                  </div>
                  <!-- 税额 -->
                  <div style="flex: 1.8">
                    <input type="text" v-model="data.taxAmountPayables" readonly style="text-align: center" />
                  </div>
                </div>
              </div>
              <div class="invoice-sum">
                <span>￥{{ moneyAmount | tofixed }}</span>
                <span>￥{{ rateMoneyAmount | tofixed }}</span>
              </div>
              <div class="invoice-taxsum">
                <span>{{ moneyAndRate | filterMoney }}</span>
                <span>￥{{ moneyAndRate | tofixed }}</span>
              </div>
              <div class="invoice-saler">
                <div class="left">
                  <input type="text" v-model="enterprise.enterpriseName" />
                  <input type="text" v-model="enterprise.enterpriseTaxpayerId" />
                  <input type="text" v-model="enterprise.enterpriseAddress" />
                  <input type="text" v-model="enterprise.enterpriseAccounts" />
                </div>
                <div class="right">
                  <textarea v-model="enterprise.remake" placeholder="请输入备注信息"></textarea>
                </div>
              </div>
              <div class="invoice-footer">
                <div class="payee"><input type="text" v-model="enterprise.payee" /></div>
                <div class="review"><input type="text" v-model="enterprise.rechecker" /></div>
                <div class="billing">{{ enterprise.drawer }}</div>
              </div>
            </div>
            <!-- 打印页面 -->
            <div
              class="cont-invoice"
              v-show="isInPrint"
              ref="invoice"
              :class="kpdate.taxClass == 0 ? 'zy' : kpdate.taxClass == 1 ? 'pt' : 'dz'"
            >
              <div class="invoice-header">
                <span class="no-print" :style="{ left: kpdate.taxClass == 3 ? '294px' : '340px' }">{{
                  enterprise.domainName
                }}</span>
              </div>
              <div class="invoice-no">
                <div class="version no-print"><span class="no-print">税收分类编码版本号:39.0</span></div>
                <div>
                  <select name="" id="" class="code no-print">
                    <option value="1">{{ kpdate.taxBillCode }}</option>
                  </select>
                  <select name="" id="" class="number no-print">
                    <option value="1">{{ kpdate.taxBillNo }}</option>
                  </select>
                  <div class="date">
                    <span>{{ enterprise.taxBillDate | filterDate }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-buyer">
                <div class="left">
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerName" />
                    <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerTaxpayerId" />
                    <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerAddress" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerAccounts" />
                  </div>
                </div>
                <div class="right" v-if="kpdate.taxClass === 3">
                  <input type="text" />
                  <input type="text" />
                  <input type="text" />
                </div>
              </div>
              <div class="invoice-table unborder" style="min-height: 189px">
                <div class="table-header tab no-print">
                  <!-- <div style="flex: 0.3">
                    <input type="checkbox" name="" id="" v-model="allChecked" @change="checkAll()" />
                  </div> -->
                  <div class="no-print" style="flex: 2.3">货物或应税劳务、服务名称</div>
                  <div class="no-print" style="flex: 1.15">规格型号</div>
                  <div class="no-print" style="flex: 0.6">单位</div>
                  <div class="no-print" style="flex: 0.95">数量</div>
                  <div class="no-print" style="flex: 1.3">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div class="no-print" style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div class="no-print" style="flex: 0.5">税率</div>
                  <div class="no-print" style="flex: 1.8">税额</div>
                </div>
                <div class="table-content tab" :class="isRed ? 'red' : ''" v-for="(data, i) in kpList" :key="i">
                  <!-- <div style="flex: 0.3; text-align: center">
                    <input type="checkbox" name="" id="" v-model="data.checked" @change="checkChange(data, i)" />
                  </div> -->
                  <!-- 货物或应税劳务、服务名称 -->
                  <div style="flex: 2.3">
                    <div class="relative">
                      <input class="unborder" type="text" v-model="data.goodsName" :readonly="!onlyQd" />
                      <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd" />
                    </div>
                  </div>
                  <!-- 规格型号 -->
                  <div style="flex: 1.15">
                    <input class="unborder" type="text" v-model="data.goodsGauge" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 单位 -->
                  <div style="flex: 0.6">
                    <input class="unborder" type="text" v-model="data.goodsUnits" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 数量 -->
                  <div style="flex: 0.95">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsAmounts"
                      @change="goodsAmountsChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 单价 -->
                  <div style="flex: 1.3">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsUnitPrice"
                      @change="goodsUnitPriceChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 金额 -->
                  <div style="flex: 1.5">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      readonly
                    />
                  </div>
                  <!-- 税率 -->
                  <div style="flex: 0.5">
                    <select
                      class="unborder"
                      style="text-align: center"
                      v-model="data.goodsTaxRates"
                      @change="rateChange(i)"
                      :disabled="data.goodsName && isDisOnly(data, i)"
                    >
                      <option value="0.13">13%</option>
                      <option value="0.09">9%</option>
                      <option value="0.06">6%</option>
                      <option value="0.05">5%</option>
                      <option value="0.03">3%</option>
                      <option value="0.01">1%</option>
                      <option value="0.00">0%</option>
                      <option value="0.00">免税</option>
                      <option value="0.04">4%</option>
                    </select>
                  </div>
                  <!-- 税额 -->
                  <div style="flex: 1.8">
                    <input
                      class="unborder"
                      type="text"
                      v-model="data.taxAmountPayables"
                      readonly
                      style="text-align: center"
                    />
                  </div>
                </div>
              </div>
              <div class="invoice-sum">
                <span>￥{{ moneyAmount | tofixed }}</span>
                <span>￥{{ rateMoneyAmount | tofixed }}</span>
              </div>
              <div class="invoice-taxsum">
                <span>{{ moneyAndRate | filterMoney }}</span>
                <span>￥{{ moneyAndRate | tofixed }}</span>
              </div>
              <div class="invoice-saler">
                <div class="left">
                  <input class="unborder" type="text" v-model="enterprise.enterpriseName" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseTaxpayerId" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseAddress" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseAccounts" />
                </div>
                <div class="right">
                  <textarea class="unborder" v-model="enterprise.remake" placeholder="请输入备注信息"></textarea>
                </div>
              </div>
              <div class="invoice-footer">
                <div class="payee"><input class="unborder" type="text" v-model="enterprise.payee" /></div>
                <div class="review"><input class="unborder" type="text" v-model="enterprise.rechecker" /></div>
                <div class="billing">{{ enterprise.drawer }}</div>
              </div>
            </div>
            <div class="cont-op"></div>
          </div>
        </div>
      </div>
    </pop-modal>
    <!-- 打印弹窗 -->
    <print
      ref="printModal"
      @printFp="printFpChange('Y')"
      @cancelFPrintFp="printFpChange('N')"
      @emitClosePrint="emitClosePrint"
    ></print>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, checkObjectOfNull, keepTwoDecimalFull, changeNumMoneyToChinese } from '@/utils/util'
import { mapGetters, mapActions } from 'vuex'
import Print from '@/components/Print/print.vue'
import Utils from '@/utils/oss.util'
export default {
  components: {
    Print,
  },
  data() {
    return {
      visible: false,
      kpdate: {
        taxClass: 0,
        isShow: false,
        icManageId: '',
        taxBillCode: '',
        taxBillNo: '',
      },
      enterprise: {
        buyerAccounts: '',
        buyerAddress: ' ',
        buyerName: '',
        buyerTaxpayerId: '',
        domainName: '',
        enterpriseAccounts: '',
        enterpriseAddress: '',
        enterpriseName: '',
        enterpriseTaxpayerId: '',
        taxBillDate: '',
        drawer: '',
      },
      selectedData: [],
      allChecked: false,
      detailId: '',
      onlyQd: false,
      detailedList: [],
      kpList: [],
      price: 'taxfree',
      moneyAmount: '',
      rateMoneyAmount: '',
      moneyAndRate: '',
      isRed: false,
      isInPrint: false,
      // 折扣
      discountRate: '', // 折扣税率
      discountAmount: '', // 折扣金额
      disGoodsAmount: 0, // 商品金额
      isDiscountSubmit: false,
    }
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA', 'ENTERPRISE']),
  },
  filters: {
    filterDate(v) {
      const dateArr = v.split('-')
      return v.length ? `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日` : ''
    },
    filterMoney(money) {
      return changeNumMoneyToChinese(money)
    },
    tofixed(v) {
      return v ? v.toFixed(2) : '0.00'
    },
  },
  methods: {
    async show(params) {
      this.visible = true
      this.kpList = params.studentReportTaxBList
      const cloneObj = params.detail
      this.setParam(this.enterprise, cloneObj)
      this.setParam(this.kpdate, cloneObj)
      console.log(this.enterprise)
      console.log(this.kpdate)
      this.amountMoney()
    },
    handelCancel() {
      this.visible = false
    },
    setParam(obj, cloneObj) {
      for (const key in cloneObj) {
        if (Object.hasOwnProperty.call(cloneObj, key)) {
          const element = cloneObj[key]
          obj[key] = element
        }
      }
    },
    // 冲红
    chonghong() {
      this.isRed = !this.isRed
      this.kpList.forEach((v) => {
        v.goodsAmounts = -v.goodsAmounts
        v.goodsUnitPrice = -v.goodsUnitPrice
        v.goodsPriceAmounts = -v.goodsPriceAmounts
      })
      this.kpList = this.transChange(this.kpList)
      this.amountMoney()
    },
    // 初始化发票数据
    initVoiceData() {
      this.kpList = []
      this.selectedData = []
      this.price = 'taxfree'
      this.moneyAmount = ''
      this.rateMoneyAmount = ''
      this.moneyAndRate = ''
      this.kpdate.icManageId = ''
      this.isRed = false
    },
    // 多选
    // checkAll() {
    //   if (this.allChecked) {
    //     this.kpList.forEach((data, i) => {
    //       data.checked = true
    //       this.selectedData.push(data)
    //     })
    //   } else {
    //     this.initSelected()
    //     this.kpList.forEach((v) => (v.checked = false))
    //   }
    // },
    // checkChange(data, i) {
    //   if (data.checked) {
    //     // data.checked = true
    //     this.selectedData.push(data)
    //   } else {
    //     // data.checked = false
    //     this.selectedData = this.selectedData.filter((v) => v.checked)
    //   }
    //   this.allChecked = this.selectedData.length === this.kpList.length
    // },
    // 初始化全选
    initSelected() {
      this.selectedData = []
      this.allChecked = false
    },
    isDisOnly(data, i) {
      return data.isDiscount || (this.kpList[i + 1] && this.kpList[i + 1].isDiscount)
    },

    // 是否含税切换
    priceChange() {
      const list = this.kpList
      if (list == null || list.length < 1) {
        this.$info({
          title: '提示',
          content: '数据为空!',
        })
        return
      }
      this.price = this.price === 'taxfree' ? 'unit' : 'taxfree'
      for (let i = 0; i < list.length; i++) {
        if (list[i].goodsTaxRates !== null || list[i].goodsTaxRates !== 0) {
          const num = (100 + list[i].goodsTaxRates * 100) / 100
          const s = list[i].goodsUnitPrice
          // 第一个计算式为不含税，第二个为含税
          // 如果列表为折扣列表，则不进行单价计算
          if (!list[i].isDiscount) {
            list[i].goodsUnitPrice =
              this.price === 'taxfree' ? Number((s * num).toFixed(4)) : Number((s / num).toFixed(4))
          }
          this.calcPriceAmounts(i)
        }
      }
      this.amountMoney()
    },
    // 初始化发票
    initFP(type) {
      const studentReportTaxBList = {
        goodsCodeId: '',
        goodsCodeName: '',
        goodsName: '',
        goodsGauge: '',
        goodsUnits: '',
        goodsAmounts: '',
        // 不含税单价
        goodsUnitPrice: '',
        // 含税单价
        unitprice: '',
        goodsPriceAmounts: '',
        unitmoney: '',
        goodsTaxRates: '0.13',
        taxAmountPayables: '',
        hasTax: '',
        alias: '',
        checked: false, // 是否被选中
        isDiscount: type === 'discount', // 是否为折扣行
      }
      return studentReportTaxBList
    },
    // 进行下一个开票
    async nextFptk() {
      this.initVoiceData()
      const params = parseParam({
        taxClass: this.kpdate.taxClass,
        icManageId: this.kpdate.icManageId ? this.kpdate.icManageId : '',
      })
      const res = await this.$http.post(`${Urls.openInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.kpdate.icManageId = res.icManageId
        this.kpdate.taxBillNo = res.taxBillNo
        this.kpdate.taxBillCode = res.taxBillCode
      }
    },
    // 获取 enterprise 信息
    async generateInvoice() {
      const task = await this.getTasksBySeq(4)
      if (checkObjectOfNull(task)) {
        return
      } else {
        this.taskData = task
      }
      const params = parseParam({
        moduleId: this.taskData.id,
        icManageId: this.kpdate.icManageId,
        taxBillNo: this.kpdate.taxBillNo,
      })
      const res = await this.$http.post(`${Urls.generateInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.detailId = res.detailId
        this.enterprise = res.enterprise
        this.enterprise.domainName = this.ENTERPRISE.domainName
      }
    },
    /**
     * 数量变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsAmountsChange(i) {
      const listItem = this.kpList[i]
      // 单价 和金额为空时 不做操作
      if (!listItem.goodsUnitPrice && !listItem.goodsPriceAmounts) return
      if (listItem.goodsUnitPrice == null && listItem.goodsPriceAmounts != null) {
        // 单价为空 金额不为空 计算单价
        this.calcUnitPrice(i)
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 单价变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsUnitPriceChange(i) {
      const listItem = this.kpList[i]
      // 数量 和 金额 为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsPriceAmounts) return
      // 数量为空 金额不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsPriceAmounts != null) {
        this.calcAmounts(i) // 计算数量
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 金额改变
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables税额   goodsTaxRates 税率
     * @param i
     */
    taxAmountPayablesChange(i) {
      const listItem = this.kpList[i]
      // 数量 和单价为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsUnitPrice) return
      // 数量为空 单价不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsUnitPrice != null) {
        this.calcAmounts(i) // 计算数量
      }
      listItem.goodsPriceAmounts = Number(listItem.goodsPriceAmounts).toFixed(2) // 转换金额为小数点后两位
      this.calcUnitPrice(i) // 计算单价
      this.rateChange(i)
      this.amountMoney()
    },
    // 计算数量
    calcAmounts(i) {
      const listItem = this.kpList[i]
      listItem.goodsAmounts = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsUnitPrice) // 计算数量
    },
    // 计算单价
    calcUnitPrice(i) {
      const listItem = this.kpList[i]
      listItem.goodsUnitPrice = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsAmounts).toFixed(2) // 计算单价
    },
    // 计算金额
    calcPriceAmounts(i) {
      const listItem = this.kpList[i]
      const calcItem = listItem.isDiscount ? this.kpList[i - 1] : listItem
      listItem.goodsPriceAmounts = keepTwoDecimalFull(calcItem.goodsUnitPrice * calcItem.goodsAmounts).toFixed(2) // 计算金额
    },
    // 计算税额
    rateChange(i) {
      const listItem = this.kpList[i]
      const calcItem = listItem.isDiscount ? this.kpList[i - 1] : listItem
      if (this.price === 'taxfree') {
        listItem.taxAmountPayables = keepTwoDecimalFull(calcItem.goodsPriceAmounts * calcItem.goodsTaxRates).toFixed(2) // 税额 等于金额*税率
      } else {
        // 税额为含税时应该计算不含税金额的税率
        const num = (100 + calcItem.goodsTaxRates * 100) / 100
        const s = calcItem.goodsUnitPrice
        const goodsUnitPrice = keepTwoDecimalFull(s / num).toFixed(2)
        const goodsPriceAmounts = (Number(goodsUnitPrice) * listItem.goodsAmounts).toFixed(2)
        listItem.taxAmountPayables = (Number(goodsPriceAmounts) * calcItem.goodsTaxRates).toFixed(2)
      }
    },
    // 计算总额
    amountMoney() {
      this.moneyAmount = 0
      this.rateMoneyAmount = 0
      this.moneyAndRate = 0
      for (let i = 0; i < this.kpList.length; i++) {
        if (this.price === 'taxfree') {
          this.moneyAmount += Number(this.kpList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.kpList[i].taxAmountPayables)
        } else {
          this.moneyAmount += Number(this.kpList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.kpList[i].taxAmountPayables)
        }
      }
      if (this.price === 'taxfree') {
        this.moneyAndRate = Number((this.moneyAmount + this.rateMoneyAmount).toFixed(2))
      } else {
        this.moneyAndRate = Number(this.moneyAmount.toFixed(2))
      }
    },
    // 红字开票的税率转换以及List重新编排
    transChange(list) {
      const listData = []
      for (let i = 0; i < list.length; i++) {
        const rate = parseFloat(list[i].goodsTaxRates.toString().replace('%', ''))
        const sublist = {
          alias: '*' + list[i].goodsCodeName + '*' + list[i].goodsName,
          goodsCodeId: list[i].goodsCodeId,
          goodsCodeName: list[i].goodsCodeName,
          goodsName: list[i].goodsName,
          goodsGauge: list[i].goodsGauge,
          goodsUnits: list[i].goodsUnits,
          goodsAmounts: keepTwoDecimalFull(parseFloat(list[i].goodsAmounts)),
          // 不含税单价
          goodsUnitPrice: keepTwoDecimalFull(parseFloat(list[i].goodsUnitPrice)),
          // 含税单价
          unitprice: keepTwoDecimalFull(parseFloat(list[i].goodsUnitPrice) * (1 + rate)),
          goodsPriceAmounts: keepTwoDecimalFull(parseFloat(list[i].goodsPriceAmounts)),
          unitmoney: keepTwoDecimalFull(parseFloat(list[i].goodsPriceAmounts) * (1 + rate)),
          goodsTaxRates: rate,
          taxAmountPayables: keepTwoDecimalFull(parseFloat(list[i].taxAmountPayables)).toFixed(2),
          hasTax: '',
        }
        listData.push(sublist)
      }
      return listData
    },
    // 发票保存 这个模块没有用到
    async printSave() {
      const dataDetail = this.getParam()
      if (dataDetail === undefined || dataDetail === null) return
      // 总价为负数则任务是开负数
      if (Number(this.rateMoneyAmount) < 0) {
        const task = Utils.getTaskDataByModType('8')
        if (checkObjectOfNull(task)) {
          this.$error({
            title: '警告',
            content: '暂无负数发票业务!',
          })
          return
        } else {
          this.taskData = task
        }
      }
      const params = parseParam({
        moduleId: this.taskData.id,
        icManageId: this.kpdate.icManageId ? this.kpdate.icManageId : '',
        taxClass: this.kpdate.taxClass,
        isTax: this.price === 'price' ? 1 : 0,
        data: JSON.stringify(dataDetail),
        detailId: this.detailId,
      })
      const res = await this.$http.post(`${Urls.saveInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.onlyQd = false
        await this.uploadTestByOSS({ result: res, isFinish: '2' })
        await this.getBusinessList()
        this.handelCancel() // 关闭弹框
        this.showPrint() // 显示打印框
        this.invoiceId = res.invoiceId
      }
    },
    getParam() {
      // const studentReportTaxBList = []
      // if (this.onlyQd === true) {
      //   this.isMenu = 'Y'
      //   Object.assign(studentReportTaxBList, this.detailedList)
      // } else {
      //   Object.assign(studentReportTaxBList, this.kpList)
      // }
      let params = {
        id: '',
        taxBillCode: this.kpdate.taxBillCode,
        taxBillNo: this.kpdate.taxBillNo,
        taxBillDate: this.enterprise.taxBillDate,
        buyerName: this.enterprise.buyerName,
        buyerTaxpayerId: this.enterprise.buyerTaxpayerId,
        buyerAddress: this.enterprise.buyerAddress,
        buyerAccounts: this.enterprise.buyerAccounts,
        totalGoodsPrices: Number(this.moneyAmount),
        totalTaxPays: Number(this.rateMoneyAmount),
        totalLowerPrices: Number(this.rateMoneyAmount + this.moneyAmount),
        enterpriseName: this.enterprise.enterpriseName,
        enterpriseTaxpayerId: this.enterprise.enterpriseTaxpayerId,
        enterpriseAddress: this.enterprise.enterpriseAddress,
        remark: this.enterprise.remake,
        drawer: this.enterprise.drawer,
        rechecker: this.enterprise.rechecker,
        payee: this.enterprise.payee,
        isMenu: this.isMenu,
        stuId: this.LOGIN_INFO.stuId,
        enterpriseId: this.LOGIN_INFO.eid,
        studentReportTaxBList: this.kpList,
      }
      // 保存的时候做字段校验
      if (!this.enterprise.buyerName) {
        this.$error({
          title: '警告',
          content: '购方姓名为空',
        })
        return
      }
      const list = params.studentReportTaxBList
      if (list.length <= 0) {
        this.$error({
          title: '警告',
          content: '请先添加商品',
        })
        return
      }
      for (let i = 0; i < list.length; i++) {
        if (!list[i].goodsName) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行货物或应税劳务，服务名称不能为空',
          })
          return
        } else if (!list[i].goodsAmounts) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行数量不能为空',
          })
          return
        } else if (!list[i].goodsUnitPrice) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行单价不能为空',
          })
          return
        } else if (!list[i].goodsPriceAmounts) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行金额不能为空',
          })
          return
        } else if (!list[i].goodsTaxRates) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行税率不能为空',
          })
          return
        }
      }
      if (this.price !== 'taxfree') {
        // 当前数据为不含税数据
        this.priceChange()
        params = this.getParam()
      }
      return params
    },
    // 显示打印弹框
    showPrint() {
      this.isInPrint = true
      this.$refs.printModal.show()
    },
    // 关闭打印弹框
    closePrint() {
      this.isInPrint = false
      this.$refs.printModal.close()
    },
    //
    emitClosePrint() {
      this.isInPrint = false
    },
    // 点击打印/不打印
    async printFpChange(type) {
      if (type === 'N') {
        this.$info({
          title: '提示',
          content: '不打印，但数据已经保存！',
        })
      } else if (type === 'Y') {
        this.$print(this.$refs.invoice)
      }
      this.closePrint()
      this.handelCancel() // 关闭弹框
    },
    ...mapActions('practice', ['getTasksBySeq']),
  },
}
</script>

<style lang="less" scoped>
@left: 15px;
@top: 5px;

.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #000;
}
.main {
  background-color: #e4e7fa;
  flex: 1;
  .main-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    button {
      margin: 0 5px;
    }
  }
}
.main-cont {
  display: flex;
  flex: 1;
  justify-content: space-around;
  .cont-invoice {
    &.pt {
      background-image: url('~@/assets/invoice-pt.png');
    }
    &.zy {
      background-image: url('~@/assets/invoice-zy.png');
    }
    &.dz {
      background-image: url('~@/assets/invoice-dzpt.png');
    }
    // width: 1137px;
    // height: 665px;
    width: 878px;
    height: 500px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 5px;
    position: relative;
    .invoice-header {
      height: 78px;
      display: block;
      font-size: 22px;
      font-family: '宋体';
      font-weight: 700;
      border: none;
      color: #9d5426;
      position: relative;
      span {
        position: absolute;
        // top: 38px;
        top: @top + 24px;
      }
    }
    .invoce-invalid {
      position: absolute;
      top: 0;
      left: 630px;
      img {
        width: 170px;
      }
      span {
        position: absolute;
        top: 50px;
        left: 9px;
        font-size: 12px;
        font-weight: 700;
        color: #e60012;
      }
    }
    .invoice-no {
      // margin-top: 30px;
      .code {
        // margin-left: 164px;
        position: absolute;
        left: @left + 103px;
        top: @top + 80px;
        transform: scale(0.75);
      }
      .number {
        // margin-left: 69px;
        // position: absolute;
        // left: 362px;
        position: absolute;
        left: @left + 280px;
        top: @top + 80px;
        transform: scale(0.8);
      }
      .version {
        // text-align: right;
        // margin-right: 109px;
        position: absolute;
        top: @top + 57px;
        right: 69px;
        color: #c7c7c7;
        font-size: 12px;
        transform: scale(0.9);
      }
      .date {
        // display: inline-block;
        // position: absolute;
        // left: 944px;
        display: inline-block;
        position: absolute;
        right: 63px;
        top: @top + 70px;
        transform: scale(0.8);
      }
    }
    .invoice-buyer {
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
      }
      .left {
        display: inline-block;
        position: absolute;
        left: @left + 102px;
        top: @top + 87px;
        transform: scale(0.7);
        input {
          width: 430px;
          margin-bottom: 2px;
        }
      }
      .right {
        display: inline-block;
        /* margin-left: 79px; */
        position: absolute;
        top: @top + 112px;
        left: @left + 446px;
        transform: scale(0.7);
        input {
          width: 327px;
        }
      }
    }
    .invoice-table {
      // width: 83.4%;
      // margin-left: 8.3%;
      // margin-top: 3px;
      min-height: 189px;
      font-size: 12px;
      transform: scale(0.835);
      position: absolute;
      top: @top + 165px;
      &.unborder {
        .tab {
          display: flex;
          height: 19px;
          > div {
            border: none;
            box-sizing: border-box;
            width: 100%;
          }
        }
      }
      .tab {
        display: flex;
        height: 19px;
        > div {
          border: 1px solid #a2ddfb;
          box-sizing: border-box;
          width: 100%;
        }
      }
      .table-header {
        text-align: center;
        background-color: #cee3f4;
      }
      .table-content {
        input[type='text'],
        input[type='number'],
        select {
          width: 100%;
          height: 100%;
          border: none;
          background-color: transparent;
        }
      }
    }
    .invoice-sum {
      // height: 36px;
      // line-height: 36px;
      font-weight: 500;
      :first-child {
        position: absolute;
        left: @left + 519px;
        top: @top + 324px;
        transform: scale(0.8);
      }
      :nth-child(2) {
        position: absolute;
        left: @left + 698px;
        top: @top + 324px;
        transform: scale(0.8);
      }
    }
    .invoice-taxsum {
      height: 36px;
      line-height: 36px;
      font-weight: 500;
      :first-child {
        position: absolute;
        top: @top + 342px;
        left: @left + 250px;
        transform: scale(0.8);
      }
      :nth-child(2) {
        position: absolute;
        top: @top + 342px;
        left: @left + 655px;
        transform: scale(0.8);
      }
    }
    .invoice-saler {
      display: flex;
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
        height: 23px;
      }
      .left {
        // margin-left: 237px;
        // margin-top: 2px;
        position: absolute;
        transform: scale(0.7);
        left: @left + 90px;
        top: @top + 365px;
        input {
          width: 503px;
        }
      }
      .right {
        // margin-left: 27px;
        width: 350px;
        height: 95px;
        position: absolute;
        left: @left + 493px;
        top: @top + 364px;
        transform: scale(0.7);
        textarea {
          height: 100%;
          width: 100%;
          padding: 0;
        }
      }
    }
    .invoice-footer {
      display: flex;
      align-items: center;
      margin-top: 3px;
      .payee {
        // margin-left: 187px;
        position: absolute;
        top: @top + 446px;
        left: @left + 106px;
        transform: scale(0.7);
      }
      .review {
        position: absolute;
        // left: 442px;
        top: @top + 446px;
        left: @left + 275px;
        transform: scale(0.7);
        input {
          width: 150px;
        }
      }
      .billing {
        // position: absolute;
        // top: 604px;
        // left: 664px;
        position: absolute;
        top: @top + 448px;
        left: @left + 465px;
        transform: scale(0.8);
        font-weight: 500;
      }
      input[type='text'] {
        border: 1px solid #a2ddfb;
      }
    }
  }
  .cont-op {
    display: flex;
    flex-direction: column;
    padding: 0px;
    justify-content: center;
    button {
      margin: 5px 0;
    }
  }
}
.discountWrap {
  padding: 5% 10%;
  color: #000;
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    .left,
    .right {
      width: 45%;
      font-size: 16px;
    }
    .left {
      text-align: right;
    }
    .right {
      text-align: left;
    }
  }
}
.unborder {
  appearance: none !important;
  border: none !important;
}
.addImg {
  position: absolute;
  right: 3px;
  top: 2px;
  width: 18px;
}
.relative {
  position: relative;
}
</style>
<style lang="less">
.wrap {
  .main-top,
  .main-cont {
    .ant-btn-background-ghost {
      background-color: #fff !important;
    }
  }
}
</style>
